import {
  Train,
  Plane,
  Hospital,
  Handshake,
  Briefcase,
  Bed,
  Utensils,
  Building2,
  FileText,
  ShoppingBag,
  GraduationCap,
  Luggage,
  Baby,
  HelpingHand,
  Sparkles,
  Car,
  Wrench,
  Package,
  LineChart,
  Presentation,
  Calendar,
  Trophy,
  ShieldCheck,
} from "lucide-react";

export const SERVICE_ICONS = {
  train: Train,
  plane: Plane,
  hospital: Hospital,
  handshake: Handshake,
  briefcase: Briefcase,
  bed: Bed,
  utensils: Utensils,
  building: Building2,
  "file-text": FileText,
  "shopping-bag": ShoppingBag,
  "graduation-cap": GraduationCap,
  luggage: Luggage,
  baby: Baby,
  sparkles: Sparkles,
  car: Car,
  wrench: Wrench,
  package: Package,
  "chart-line": LineChart,
  presentation: Presentation,
  calendar: Calendar,
  trophy: Trophy,
  "shield-check": ShieldCheck,
};

export const DefaultIcon = HelpingHand;
